module.exports = "data:text/x-markdown;base64,U29tZSBjb250cmFjdHMgd2lsbCBzaW1wbHkgbm90IHRha2UgeW91ciBtb25leSBgwq9cXyjjg4QpXy/Cr2AKClRoZSBnb2FsIG9mIHRoaXMgbGV2ZWwgaXMgdG8gbWFrZSB0aGUgYmFsYW5jZSBvZiB0aGUgY29udHJhY3QgZ3JlYXRlciB0aGFuIHplcm8uCgombmJzcDsKVGhpbmdzIHRoYXQgbWlnaHQgaGVscDoKKiBGYWxsYmFjayBtZXRob2RzCiogU29tZXRpbWVzIHRoZSBiZXN0IHdheSB0byBhdHRhY2sgYSBjb250cmFjdCBpcyB3aXRoIGFub3RoZXIgY29udHJhY3QuCiogU2VlIHRoZSBIZWxwIHBhZ2UgYWJvdmUsIHNlY3Rpb24gIkJleW9uZCB0aGUgY29uc29sZSIK"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/force.md
// module id = 1377
// module chunks = 0